import React, { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { addMusic, getMusic } from "../../redux/music-redux/musicStore";

const UploadMusic = () => {
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();

  const handleUploadToggle = () => {
    setToggle(!toggle);
  };

  const [values, setValues] = useState({
    artist_name: "",
    title: "",
    producer: "",
    released: "",
    genre: "",
  });
  const [music, setMusic] = useState();
  const [poster, setPoster] = useState();

  useEffect(() => {
    getMusic(dispatch, "e0341472-2800-4597-8491-dc6ceae1e1b3");
  });

  const audio_file = useSelector(({ musicReducer: { music } }) => music);

  const audio = new Audio(audio_file !== null && audio_file.download_link);

  const handleInput = ({ target: { name, value } }) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleFile = ({ target: { files } }) => {
    setMusic(files[0]);
  };
  const handlePoster = ({ target: { files } }) => {
    setPoster(files[0]);
  };

  const onUpload = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("artist_name", values.artist_name);
    formData.append("title", values.title);
    formData.append("producer", values.producer);
    formData.append("released", values.released);
    formData.append("genre", values.genre);
    formData.append("music_file", music);
    formData.append("poster_file", poster);
    addMusic(dispatch, formData);
  };

  //   e0341472-2800-4597-8491-dc6ceae1e1b3
  return (
    <>
      <Button style={{ marginBottom: "2em" }} onClick={handleUploadToggle}>
        Upload Music
      </Button>
      <Button onClick={() => audio.play()}>Play</Button>
      {toggle && (
        <Form onSubmit={onUpload}>
          <h1>Upload Music</h1>
          <Form.Input
            label='Artist Name'
            placeholder='Artist Name'
            name='artist_name'
            value={values.artist_name}
            onChange={handleInput}
          />
          <Form.Input
            label='Title Of Song'
            placeholder='Title Of Song'
            name='title'
            value={values.title}
            onChange={handleInput}
          />
          <Form.Input
            label='Song Producer'
            placeholder='Song Producer'
            name='producer'
            value={values.producer}
            onChange={handleInput}
          />
          <Form.Input
            label='Date Released'
            placeholder='Date Released'
            name='released'
            value={values.released}
            onChange={handleInput}
          />
          <Form.Input
            label='Genre'
            placeholder='Genre'
            name='genre'
            value={values.genre}
            onChange={handleInput}
          />
          <Form.Input
            label='Upload Music File'
            type='file'
            placeholder='Upload Music File'
            name='music_file'
            onChange={handleFile}
          />
          <Form.Input
            label='Music Poster'
            type='file'
            placeholder='Music Poster'
            name='poster_file'
            onChange={handlePoster}
          />
          <Button type='submit'>Submit</Button>
        </Form>
      )}
    </>
  );
};

export default UploadMusic;
